import { h, render } from "vue";
import { showToast as _showToast, closeToast, Toast } from "vant";
import ToastContent from "@/components/base/ToastContent.vue";

export function showToast(message, duration = 2000) {
  _showToast({
    message,
    wordBreak: "break-word",
    duration,
  });
}

export function hideToast() {
  closeToast();
}

function _createCustomToast(message, type, duration = 2000) {
  // 创建临时DOM容器
  const container = document.createElement("div");
  document.body.appendChild(container);

  // 创建内容节点
  const contentNodes = h(ToastContent, { message, type });

  // 创建Toast主节点
  const toastVNode = h(
    "div",
    {
      class: "van-popup",
      style: {
        zIndex: Toast.zIndex,
        top: "0.37rem",
        left: "50%",
        transform: "translateX(-50%)",
      },
    },
    contentNodes
  );

  // 渲染到 DOM
  render(toastVNode, container);

  // 获取渲染后的元素
  const toastEl = container.firstElementChild;

  // 添加显示动画
  toastEl.classList.add("van-fade-enter-active", "van-fade-enter-to");

  // 自动关闭
  setTimeout(() => {
    // 添加关闭动画
    toastEl.classList.remove("van-fade-enter-active", "van-fade-enter-to");
    toastEl.classList.add("van-fade-leave-active", "van-fade-leave-to");

    // 动画结束后移除元素
    setTimeout(() => {
      render(null, container);
      document.body.removeChild(container);
    }, 300);
  }, duration);
}

export function showFailToast(message, duration) {
  _createCustomToast(message, "fail", duration);
}
